import configLoader from './config-loader';

// Initialize config - this will be populated after loadConfig() is called
let config = {
  REACT_APP_API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT || '',
  REACT_APP_AWS_REGION: process.env.REACT_APP_AWS_REGION || 'ap-south-1',
  REACT_APP_AD_TENANT_ID: process.env.REACT_APP_AD_TENANT_ID || 'd44ff723-4fa7-405e-afc0-43c21e573043',
  REACT_APP_AD_CLIENT_ID: process.env.REACT_APP_AD_CLIENT_ID || '',
  REACT_APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || 'dev',
  REACT_APP_URL: process.env.REACT_APP_URL || `${window.location.protocol}//${window.location.host}`
};

// Load runtime config on app initialization
configLoader.loadConfig().then(runtimeConfig => {
  Object.assign(config, runtimeConfig);
});

export default config;
